import React, {useState} from 'react';
import {Link, useParams} from "react-router-dom";
import DisplayMetaWithImport from "../components/DisplayMetaWithImport.comp";
import {formatDate} from "../../../utils/utils";

import {
    v3InstrumentBank
} from "../../../services/metadata.service";


const instrument_response_parser = (data) => {
    let str = data.trim();

    // const str_nl_arr = str.split('\n')
    // if (str_nl_arr.length > 1) {
    //     return str_nl_arr;
    // }

    let str_arr = str.split('{{');
    let output = []
    for (let i=1; i<str_arr.length; i++) {
        const option = str_arr[i].split('}}')[0];
        if (option.length > 0) {
            output.push(option);
        }
    }
    if (output.length === 0) {
        return data
    }
    return output;
}

const instrument_question_parser = (data) => {
    let str = data.trim();

    let str_arr = str.split('{{');
    if (str_arr.length > 2) {
        let output = []
        for (let i=1; i<str_arr.length; i++) {
            const option = str_arr[i].split('}}')[0];
            if (option.length > 1) {
                output.push(option);
            }
        }
        if (output.length === 0) {
            return data
        }
        return output;
    } else {
        return str;
    }
}

const additional_json_rendering_of_IR = (json_obj) => {
    if (typeof json_obj['instrument_response'] === 'object') {
        json_obj['instrument_response'] = JSON.stringify(json_obj['instrument_response']);
        json_obj['instrument_response_type'] = 'JSON'
    } else {
        json_obj['instrument_response_type'] = 'STRING'
    }

    if (typeof json_obj['instrument_question'] === 'object') {
        json_obj['instrument_question'] = JSON.stringify(json_obj['instrument_question']);
        json_obj['instrument_question_type'] = 'JSON'
    } else {
        json_obj['instrument_question_type'] = 'STRING'
    }
    return json_obj;
}


const columns = [
    { name: 'Source', key: 0, json_key: 'source', data_key: 'source' },
    { name: 'Source Order', key: 1, json_key: 'source_order', data_key: 'source_order' },
    // { name: 'OLD Program 1', key: 2, json_key: 'old_program_1', data_key: 'old_program_1' },
    // { name: 'ProgL1', key: 3, json_key: 'program_l1', data_key: 'program_l1' },
    // { name: 'ProgL5', key: 4, json_key: 'prog_l5', data_key: 'prog_l5' },
    // { name: 'Program Order within ProgL5', key: 5, json_key: 'program_order', data_key: 'program_order' },
    // { name: 'ProgL6', key: 6, json_key: 'prog_l6', data_key: 'prog_l6' },
    // { name: 'Category13 (AppInclusion)', key: 7, json_key: 'default_inclusion', data_key: 'default_inclusion' },
    { name: 'Category14 (Qimportance)', key: 5, json_key: 'importance', data_key: 'importance' },
    // { name: 'Pre-Post', key: 9, json_key: 'selection_key', data_key: 'selection_key' },
    { name: 'DQC#', key: 6, json_key: 'dqc_no', data_key: 'dqc_no' },
    { name: 'DQCO#', key: 7, json_key: 'dqco_no', data_key: 'dqco_no' },
    { name: 'Level8', key: 8, json_key: 'unit_no', data_key: 'unit_no' },
    { name: 'Level9', key: 9, json_key: 'session_no', data_key: 'session_no' },
    { name: 'Element#', key: 10, json_key: 'element_no', data_key: 'element_no' },
    { name: 'Level10', key: 11, json_key: 'element_code', data_key: 'element_code' },
    // { name: 'IndexL10_TF', key: 17, json_key: 'index_lvl10_bool', data_key: 'index_lvl10_bool' },
    // { name: 'DQSeal_Enable', key: 18, json_key: 'dqseal_enable', data_key: 'dqseal_enable' },
    { name: 'Category108 (TargetAudience)', key: 12, json_key: 'category_108', data_key: 'category_108_data' },
    { name: 'Question(sub title 1 -top)', key: 13, json_key: 'question_subtitle_top', data_key: 'question_subtitle_top' },
    { name: 'Question(sub title 2 - bottom)', key: 14, json_key: 'question_subtitle_bottom', data_key: 'question_subtitle_bottom' },
    { name: 'Programming Guide', key: 15, json_key: 'programming_guide', data_key: 'programming_guide' },
    { name: 'Programming Rules', key: 16, json_key: 'ui_rules', data_key: 'ui_rules' },
    { name: 'Final Instrument Question', key: 17, json_key: 'instrument_question', data_key: 'instrument_question_data', data_parser: instrument_question_parser },
    { name: 'Final Instrument Response', key: 18, json_key: 'instrument_response', data_key: 'instrument_response_data', data_parser: instrument_response_parser },
    { name: 'Category11 (InstrumentType)', key: 19, json_key: 'category_11', data_key: 'category_11_data' },
    { name: 'Correct Answers', key: 20, json_key: 'correct_answer', data_key: 'correct_answer' },
    { name: 'Category 115 (Difficulty)', key: 21, json_key: 'category_115', data_key: 'category_115' },
    { name: 'Program Code (X)', key: 22, json_key: 'external_score_code', data_key: 'external_score_code' },
    { name: 'Assess10', key: 23, json_key: 'raw_data_code', data_key: 'raw_data_code' },
    // { name: 'Unique code combination', key: 31, json_key: 'unique_code', data_key: 'unique_code' },
    { name: '(Assess10) X Value Range', key: 24, json_key: 'raw_data_value', data_key: 'raw_data_value' },
    { name: 'Transformed Score Code (Assess10) (Y)', key: 25, json_key: 'score_code', data_key: 'score_code' },
    { name: 'Transformation Function Y = f(X)', key: 26, json_key: 'score_function', data_key: 'score_function' },
    // { name: 'Categorized Score Code (Assess10) (YC)', key: 35, json_key: 'score_code_yc', data_key: 'score_code_yc' },
    // { name: 'Transformation Function (YC = f(Y))', key: 36, json_key: 'yc_transformation', data_key: 'yc_transformation' },
    // { name: 'Conversion of DQW raw data (X1) to DQApp (X2)', key: 37, json_key: 'conversion_dqw', data_key: 'conversion_dqw' },
    { name: 'Asses4#', key: 27, json_key: 'module_code', data_key: 'module_code' },
    { name: 'Asses6#', key: 28, json_key: 'indicator_code', data_key: 'indicator_code' },
    { name: 'COSI Session', key: 31, json_key: 'cosi_session', data_key: 'cosi_session' },
    { name: 'COSI Session Code', key: 32, json_key: 'cosi_session_code', data_key: 'cosi_session_code' },
];

const tableCols = [
    // {
    //     label: 'Unique Code',
    //     field: 'unique_code', width: 150
    // },
    {
        label: 'Assess10',
        field: 'raw_data_code', width: 150
    },
    {
        label: 'DQC#',
        field: 'dqc_no', sort: 'disabled', width: 150
    },
    {
        label: 'DQC0#',
        field: 'dqco_no', sort: 'disabled', width: 150
    },
    {
        label: 'Program Code (X)',
        field: 'external_score_code', sort: 'disabled', width: 150
    },
    // {
    //     label: 'Level10',
    //     field: 'level10', width: 150
    // },
    {
        label: 'Instrument Question',
        field: 'instrument_question', width: 150
    },
    {
        label: 'InstrumentType (Cat11)',
        field: 'category_11', width: 150
    },
    {
        label: 'Created',
        field: 'createdAt', width: 150
    },
    {
        label: 'Updated',
        field: 'updatedAt', width: 150
    },
    {
        label: 'Actions',
        field: 'actions', sort: 'disabled', searchable: false
    }
]


export default function InstrumentBankPage() {

    const { url_param_str } = useParams();
    const search_query = url_param_str.split('=').length > 1 ? url_param_str.split('=')[1]  : '';

    const table_row__additional_rendering = (row) => {

        let ir_output = '';
        let iq_output = '';
        if (row.instrument_response_type === 'JSON') {
            const ir_data_cp = JSON.parse(row.instrument_response);

            if (Array.isArray(ir_data_cp)) {
                let spans = [];
                for (let item of ir_data_cp) {
                    spans.push(<span className={'meta-data-table-array-span'}>{item}</span>);

                    ir_output += `{{${item}}}`
                    ir_output += '\n'
                }
                row.instrument_response = spans;
            } else {
                row.instrument_response = ir_data_cp;
                ir_output = ir_data_cp;
            }
        } else {
            ir_output = row.instrument_response
        }

        if (row.instrument_question_type === 'JSON') {
            const iq_data_cp = JSON.parse(row.instrument_question);

            if (Array.isArray(iq_data_cp)) {
                let spans = [];
                for (let item of iq_data_cp) {
                    spans.push(<span className={'meta-data-table-array-span'}>{item}</span>);

                    iq_output += `(${item})`
                    iq_output += '\n'
                }
                row.instrument_question = spans;
            } else {
                row.instrument_question = iq_data_cp;
                iq_output = iq_data_cp;
            }
        } else {
            iq_output = row.instrument_question
        }

        row.instrument_response_data = ir_output;
        row.instrument_question_data = iq_output;


        const cat_108_data = row.category_108;
        row.category_108_data = cat_108_data;
        row.category_108 = <Link to={`/meta_data/cat108/q=${cat_108_data}`} className={'meta-data-table-entity-link'}>{cat_108_data}</Link>;

        const cat_11_data = row.category_11;
        row.category_11_data = cat_11_data;
        row.category_11 = <Link to={`/meta_data/cat11/q=${cat_11_data}`} className={'meta-data-table-entity-link'}>{cat_11_data}</Link>;

        const create_data = formatDate(row.createdAt) + ',\n ' + (row.createdBy ? row.createdBy : '');
        row.createdAt = create_data;

        const update_data = formatDate(row.updatedAt) + ',\n ' + (row.updatedBy ? row.updatedBy : '');
        row.updatedAt = update_data;

        return row;
    }

    return (
        <DisplayMetaWithImport
            title={'Instrument Bank'}
            modal_title={'InstrumentBank - Data Preview'}
            sheet_name={'InstrumentBank-All'}
            columns={columns}
            tableCols={tableCols}
            jsonSpRender={additional_json_rendering_of_IR}
            tableSpRender={table_row__additional_rendering}
            search_query={search_query}
            listAPI={v3InstrumentBank.listData}
            postAPI={v3InstrumentBank.postData}
            deleteAPI={v3InstrumentBank.deleteEntity}
            updateAPI={v3InstrumentBank.updateEntity}
            preRemoveAPI={v3InstrumentBank.preRemoveCheck}
        />
    );
}
